import { forwardRef } from 'react'

import Profile from '@/components/Chat/Profile'
import { Persona } from '@/state/AppConfig'

export type ConversationProps = {
  children: React.ReactNode
  className?: string
  persona: Persona
  appearProfile?: boolean
  ariaHeading?: string
}

const Conversation = forwardRef<HTMLDivElement, ConversationProps>(
  ({ className, persona, children, appearProfile = true, ariaHeading }, ref) => {
    return (
      <div ref={ref} className={`${className ? className : ''} relative w-full md:h-screen inset-0`}>
        <div
          className='w-full max-h-full max-md:vert-container md:container FocusStart rounded-24 focus-visible:outline focus-visible:outline-2 outline-scarlet outline-offset-2'
          tabIndex={-1}
        >
          <div className='Conversation__Inner contents'>
            {ariaHeading && <h1 className='sr-only'>{ariaHeading}</h1>}
            <Profile
              className='col-start-4 col-span-6 h-32'
              persona={persona}
              appear={appearProfile}
              noAnimation={true}
            />
            <div className='col-start-4 col-span-6'>{children}</div>
          </div>
        </div>
      </div>
    )
  }
)
export default Conversation
